import { ReactNode } from 'react'
import styled from 'styled-components'
import Text from '@components/Text'
import { H5 } from '@components/Heading'

interface SimpleItemProps {
  icon: ReactNode
  title: string | ReactNode
  description?: string
}

const Container = styled.div`
  contain: layout;
  overflow: hidden;
`

const Icon = styled.div`
  height: 6.4rem;
`

const Title = styled(H5)`
  font-weight: 500;
`

const SimpleItem: React.FC<SimpleItemProps> = ({
  icon,
  title,
  description,
}) => (
  <Container className="container">
    <Icon className="icon">{icon}</Icon>
    <Title className="title">{title}</Title>
    {description && (
      <Text className="description my-0" size="normal">
        {description}
      </Text>
    )}
  </Container>
)

export default SimpleItem
